import http from './_http'

const WMDS = (m) => { return http.post(`/wmds`, m); }
const WMDS_Call = (a, b, c) => WMDS({target: a, cmd : b, body: c});

const wmds = { WMDS, WMDS_Call}


export default wmds
export { WMDS, WMDS_Call }
